import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";
import { parseQueryParamsObject } from "@robe/core-utils";
import { baseWebFetchOptions } from "./options";

export interface PostProjectRegistrationParams {
  company: string;
  fullname: string;
  email: string;
  phone: string;
  projectName: string;
  projectCountry: string;
  projectOrderVolume?: number | string;
  projectDeliveryDate?: string;
  projectDetails?: string;
  locale: string;
}

export const postProjectRegistration = (
  core: XcoreCore,
  { locale, ...params }: PostProjectRegistrationParams,
  timeout?: number
): BaseApiRequest<Response> =>
  core.fetch(`/api/support/project-registration${parseQueryParamsObject({ locale })}`, {
    ...baseWebFetchOptions,
    method: "POST",
    body: JSON.stringify(params),
    timeout,
  });
